import React, { FC, useEffect, useRef, useState } from "react";
import Dialog from "../../dialog";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
  PasswordWrapper,
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import * as yup from 'yup';
import { useFormik } from 'formik';
import Select from "../../select";
import { HeadLine3 } from "../../typography/styled";
import { instanceService } from "../../../api";
import { useUi } from "../../../context/ui.context";
import TopProgress from "../../TopBarProgress";
import MatchPassword from "../../password-matches";
import Input from "../../input";
import { handleOsIcons } from "../../../hooks/useOsIcons";


type ModalProps = {
  closeModalCancel:() => void;
  closeModal:(values:any) => void;
  instanceId?:string;
  loading?:boolean;
  instance?:any;
  alertTitle?:string;
}  





const RescueInstance:FC<ModalProps> = (props) => {
  const {
    closeModalCancel,
    closeModal,
    instanceId,
    loading,
    instance,
    alertTitle,
  } = props

  const {viewAlert} = useUi()
  const [t] = useTranslation()
  const InputRef:any = useRef()
  const [activeConfirm, setActiveConfirm] = useState<boolean>(false)
  const [activeButton, setActiveButton] = useState<boolean>(false)
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [bootSource, setBootSource] = useState<any[]>([])
  const [initialValues, setInitialValues] = useState<any>({
    image:'',
    root_password:'',
  })
  const onSubmit = (values:any) => {
    closeModal(values)
  }

  const {
    values,
    errors,
    touched,
    handleSubmit,
    handleChange,
    handleBlur,
  } = useFormik({
    enableReinitialize: true,
    validationSchema: yup.object().shape({
      image: yup.string().required(`${t("REQUIRED_FIELD")}`),
      root_password: yup.string().required(`${t("ROOT_PASSWORD_REQUIRED")}`),
    }),
    initialValues: {
      ...initialValues,
    },
    onSubmit,
  });
  
  const formikProps = {
    errors,
    values,
    touched,
    handleChange,
    handleBlur,
  };
  const updateBootSource = () => {
    if(instanceId) {
      instanceService.getRescueOptions(instanceId)
      .then((res:any) => {
        setBootSource(res.data.image.pub.map((item:any) => {
          return {
            ...item,
            value: item.id,
            label: item.name,
            icon: handleOsIcons(item.os_distro)
          }
        }))
      })
      .catch((err:any) => {
        if(err?.response?.data?.detail){
          viewAlert({
            severity: 'error',
            message: err?.response?.data?.detail
          })
        }
        closeModalCancel()
      })
      .finally(() => {
        setPageLoading(false)
      })
    }
  }
  useEffect(() => {
    updateBootSource()
  },[])
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{marginTop:'10px', marginLeft:'10px'}}>
          {t("RESCUE_INSTANCE")} «{alertTitle}»
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>

        <Select
          required
          toolTip={true}
          test_id={'instance-os-select'}
          data={bootSource}
          selectedValue={values['image']}
          fieldName='image'
          onChange={(e) => handleChange('image')(e)}
          {...formikProps}
          title={t("OS")}
          customStyles={{width:'360px'}}
        />
        <PasswordWrapper>
          <Input
            required
            title={t('ROOT_PASSWORD_LABEL')}
            fieldName='root_password'
            placeholder={t('ROOT_PASSWORD_LABEL')}
            onFocus={() => setActiveConfirm(true)}
            onFocusOut={() => setActiveConfirm(false)}
            customStyles={{width:'360px'}}
            onBlur={handleBlur}
            ref={InputRef}
            isPassword
            {...formikProps}
          />
          <MatchPassword
            setEnabled={setActiveButton}
            validateString={values['root_password']}
            active={activeConfirm}
          />
        </PasswordWrapper>
        <div style={{display:"flex", gap:'6px', marginTop:'10px'}}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={t("CANCEL")}
          />
          <Button
            variant="primary"
            size="display"
            loading={loading}
            disabled={!activeButton}
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={handleSubmit}
            title={t("RESCUE")}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default RescueInstance